module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Arisdorf-28f05ee90a0fc88b255fc004af9e5189.png";